import React from 'react'
import {SEO} from '../../components/Seo/seo'
import {home} from '../../utils/pages-meta.json'
import AdminIntro from '../../components/AdminIntro'
import { useIntl } from 'react-intl'

const Home = () => {
  const intl = useIntl()
  return (
    <>
      <SEO title={intl.formatMessage({ id: 'PageTitle.Home' })}
           pathname={window.location.origin}
           titleTemplate={intl.formatMessage({ id: 'E-Tax' })}
           image={home.image}
           description={intl.formatMessage({ id: 'PageTitle.Home' })}
      />
      <AdminIntro/>

    </>
  )
}

export default Home
